var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card-briefing-entrega"},[_c('div',{staticClass:"card-white card-briefing rounded"},[_vm._m(0),_c('div',{staticClass:"content-text my-auto"},[_c('p',[_vm._v(_vm._s(_vm.$t("dash.entrega")))]),_c('h5',[_vm._v(_vm._s(_vm.date))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-icons terciary"},[_c('i',{staticClass:"ico-calendar"})])
}]

export { render, staticRenderFns }